import React, { useMemo } from "react";
import styles from "./ProductTitle.module.scss";

const ProductTitleComponent = ({ product, variationOptions }) => {
  const { Model, ProductTitle } = product;
  // const [showDropdown, setShowDropdown] = useState(false);

  return useMemo(() => {
    // const toggleVariant = () => {
    //   setShowDropdown(!showDropdown);
    // };

    const getModelText = () => {
      const words = Model.split('/')
      if (words.length >= 2) {
        return words.join(' / ')
      } else {
        return words.join('')
      }
    }
    return (
      <div>
        <div>
          <p className={styles.productModel}>
          {ProductTitle} - {getModelText()}
          </p>
        </div>
      </div>
    );
  }, [Model, ProductTitle]);
};

export { ProductTitleComponent };
